exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "footer#footer{background-color:#d3dff3;height:50vh;position:relative;width:100%;margin-top:40px;z-index:-1}", "", {"version":3,"sources":["C:/projects/Infrastil/evm/evm-frontend-react/src/components/layout/Footer/Footer.scss"],"names":[],"mappings":"AAEA,cACE,yBAA0B,AAC1B,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,gBAAiB,AACjB,UAAY,CAAE","file":"Footer.scss","sourcesContent":["/* COLOR PALETTE */\n/* SIZINGS */\nfooter#footer {\n  background-color: #d3dff3;\n  height: 50vh;\n  position: relative;\n  width: 100%;\n  margin-top: 40px;\n  z-index: -1; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":false,"sourceMap":true,"minimize":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/components/layout/Footer/Footer.scss
// module id = 736
// module chunks = 0